import { render, staticRenderFns } from "./BImageLazyImgix.vue?vue&type=template&id=2a3089f9"
import script from "./BImageLazyImgix.vue?vue&type=script&lang=js"
export * from "./BImageLazyImgix.vue?vue&type=script&lang=js"
import style0 from "./BImageLazyImgix.vue?vue&type=style&index=0&id=2a3089f9&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports